import { cn } from '@discover-lib/utils';

export default function availabilityCarouselItemVariants() {
  return cn('aspect-square w-[15%] min-w-[15%] lg:w-[14.15%] lg:min-w-[14.15%]');
}
